var exports = {
  "x": "xa15a2ab7--6bea9a--button",
};

module.exports = exports;
